import { get } from '@/utils/request';

export const newss = (params) => {
  return get('/api/v1/newss', params);
};

export const news = (id) => {
  return get(`/api/v1/news/${id}`);
};
export const news_categorys = (params) => {
  return get('/api/v1/news_categorys', params);
};
